// extracted by mini-css-extract-plugin
export default {"left":"NJk47S7QD9","right-name":"_6bY4xArdFw","rightName":"_6bY4xArdFw","right":"UTjIYfcJHZ","secret-inspector":"HHiVsQ7wh7","secretInspector":"HHiVsQ7wh7","description":"obSxhiK73z"};
    if(module.hot) {
      // 1648554211203
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  